// ========================================================
// 🔧 ENVIRONMENT CONFIGURATION
// Uncomment the environment you want to use.
// ========================================================

// 🔴 TESTING / UAT ENVIRONMENT
// export const BASE_URL = "https://uatadmin.blueberrydmc.com/api";

// 🟢 PRODUCTION ENVIRONMENT
export const BASE_URL = "https://admin.blueberrydmc.com/api";